<!-- eslint-disable -->
<script setup>
import commonSvgs from '@/assets/svgs/commonSvgs.json'
import { useCustomerStore } from '@/stores/customer';
import { ref } from 'vue';
import { closeModal, confirmModal } from '@kolirt/vue-modal'
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useCurrenciesStore } from '@/stores/currencies';

const router = useRouter();
const svgs_data = commonSvgs;
const customerStore = useCustomerStore();
const direction = ref(document.dir);
const loading = ref(false)
const { t } = useI18n();
const currenciesStore = useCurrenciesStore();

const options = {
	rewind: true,
	pagination: true,
	arrows: customerStore.getUnreadDropdownNotifications.length > 1 ? true : false,
	perPage: 1,
	direction: direction,
	width: '550px',
	breakpoints: {
		350: {
			width: '320px',
		},
		425: {
			width: '350px',
		},
		475: {
			width: '425px',
		},
		500: {
			width: '475px',
		},
		525: {
			width: '500px',
		},
		550: {
			width: '525px',
		},
	},
}

const closeModalOnClickOutside = async () => {
	closeModal();
	loading.value = true;

	await customerStore.markAsReadDropdownNotifications().catch((error) => {
		console.error(error);
	});

	await customerStore.fetchCustomerDropdownNotifications().catch((error) => {
		console.error(error);
	});

	loading.value = false;
};

const goToUrl = (notification) => {
	loading.value = true;
	customerStore.markAsReadDropdownNotifications().then((response) => {
		customerStore.fetchCustomer().then((response) => {
			if (notification?.button_link_url) {
				loading.value = false;
				goToPage(notification?.button_link_url)
				closeModal();
			}
		})
	})
}

const goToPage = ((url) => {
	if (url.startsWith(process.env.VUE_APP_URL)) {
		const sliced = url.slice(process.env.VUE_APP_URL.length);
		router.push({'path': sliced});
		return;
	}

	window.location.href = url;
});

const notificationTitle = (notification) => {
	if (notification?.title == 'deposit_bonus') return t('popup_notification.deposit_bonus')
	else return notification?.title;
}

const notificationBody = (notification) => {
	if (notification.body.includes('freebet_from_deposit_received')) {
		let parts = notification.body.split(', ');
		let amount = parts[1];
		return t('popup_notification.freebet_from_deposit_received', { amount: currenciesStore.format_currency(amount, customerStore.customer.currency.code) });
	} else if (notification.body.includes('freespins_from_deposit_received')) {
		let parts = notification.body.split(', ');
		let amount = parts[1];
		return t('popup_notification.freespins_from_deposit_received', { amount: amount });
	} else return notification.body || '';
}

const notificationButton = (notification) => {
	if (!notification?.button_name) return t('general.close');
	if (notification?.button_name == 'view_deposit_bonus') return t('popup_notification.view_bonus')
	else return notification?.button_name;
}

</script>
<template>
	<div class="modal-outer verify-email-popup" ref="modal">
		<Splide v-if="customerStore.getUnreadDropdownNotifications.length > 1" :options="options">
			<SplideSlide v-for="(notification, index) in customerStore.getUnreadDropdownNotifications" :key="index">

					<div class="notification-card">
						<button class="close" @click="closeModalOnClickOutside" v-html="svgs_data.popup_cross"></button>


						<div class="modal-header" style="margin-bottom: 25px;">
							<h3>{{ notificationTitle(notification) }}</h3>
						</div>
						<div class="popup-message">
							<p v-html="notificationBody(notification)"></p>
						</div>
						<div class="password-reset-main" style="margin-top: 25px;">
							<template v-if="notification?.button_link_url">
								<a class="btn btn-secondary" v-if="loading"> <div class="loader-main"></div></a>
								<button v-else class="btn btn-secondary" type="button" @click="goToUrl(notification)">
									{{ notificationButton(notification) }}
								</button>
							</template>
							<template v-else>
								<a class="btn btn-secondary" v-if="loading"> <div class="loader-main"></div></a>
								<button v-else class="btn btn-secondary" type="button" @click="closeModalOnClickOutside">
									{{ notificationButton(notification) }}
								</button>
							</template>
						</div>

					</div>

			</SplideSlide>
		</Splide>
		<div v-else>
			<template v-if="customerStore.getUnreadDropdownNotifications.length == 1">
				<div class="notification-card">
					<button class="close" @click="closeModalOnClickOutside" v-html="svgs_data.popup_cross"></button>

					<div class="modal-header" style="margin-bottom: 25px;">
						<h3>{{ notificationTitle(customerStore.getUnreadDropdownNotifications[0]) }}</h3>
					</div>
					<div class="popup-message">
						<p v-html="notificationBody(customerStore.getUnreadDropdownNotifications[0])"></p>
					</div>
					<div class="password-reset-main" style="margin-top: 25px;">
						<template v-if="customerStore.getUnreadDropdownNotifications[0]?.button_link_url">
							<a class="btn btn-secondary" v-if="loading"> <div class="loader-main"></div></a>
							<button v-else class="btn btn-secondary" type="button" @click="goToUrl(customerStore.getUnreadDropdownNotifications[0])">
								{{ notificationButton(customerStore.getUnreadDropdownNotifications[0]) }}
							</button>
						</template>
						<template v-else>
							<a class="btn btn-secondary" v-if="loading"> <div class="loader-main"></div></a>
							<button v-else class="btn btn-secondary" type="button" @click="closeModalOnClickOutside">
								{{ notificationButton(customerStore.getUnreadDropdownNotifications[0]) }}
							</button>
						</template>
					</div>
				</div>
			</template>
		</div>

	</div>
</template>
<style scoped>
	.popup-message {
		overflow-wrap: break-word;
		word-wrap: break-word;
		color: var(--white);
	}

	.notification-card {
		background: var(--dark);
		width: 550px;
		display: flex;
		position: relative;
		flex-direction: column;
		min-height: 260px;
		align-items: center;
		justify-content: space-between;
		padding: 30px 20px;
	}

	@media screen and (min-width: 320px) and (max-width: 767px) {
		.notification-card {
			width: 100%;
			padding: 30px 20px;
		}

		.modal-outer .close {
			top: 0px;
			right: 0px;
			background: var(--dark);
			padding: 5px;
			border-radius: 50%;
			width: 32px;
		}
	}

	.btn-secondary {
		height: 42px;
		font-size: 15px;
		cursor: pointer;
	}
</style>